import svg4everybody from 'svg4everybody'

//require('./jquery')
require('./store')
require('./scrollto')
require('./modal')
require('./canvas')
require('./form')
require('./scrollreveal.min')
require('./communityApiCall')
require('./buildStore')
//require('./select2.min')

require('./creative')
require('./dynamic-pricing')
require('./map')
// require('./community_specials')
// Polyfill for external SVG spritesheets
svg4everybody()



// WEBPACK FOOTER //
// ./src/assets/js/main.js